export default {"src":"/_next/static/media/surfing.1eb8fbd6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};